import { combineReducers } from "redux";
import managersReducer from "./managersReducer";
import productsReducer from "./productsReducer";
import coveragesReducer from "./coveragesReducer";
import countriesReducer from "./countriesReducer";
import countrycodesReducer from "./countrycodesReducer";
import municipiosReducer from "./municipiosReducer";
import suppliersReducer from "./suppliersReducer";
import zonesReducer from "./zonesReducer";
import categoriesReducer from "./categoriesReducer";
import groupsReducer from "./groupsReducer";
import usersReducer from "./usersReducer";
import officesReducer from "./officesReducer";
import promotionsReducer from "./promotionsReducer";
import tagsReducer from "./tagsReducer";
import businessUnitsReducer from "./businessUnitsReducer";
import currenciesReducer from "./currenciesReducer";
import passengersReducer from "./passengersReducer";
import loginReducer from "./loginReducer";
import reservationsReducer from "./reservationsReducer";
import conciliationsReducer from "./conciliationsReducer";
import vouchersReducer from "./vouchersReducer";
import billingsReducer from "./billingsReducer";
import ratesReducer from "./ratesReducer";
import productsSpertaReducer from "./productsSpertaReducer";
import facturacionReducer from "./facturacionReducer";
import blacklistReducer from "./blacklistReducer";
import paymentDetailReducer from "./paymentDetailReducer";
import discountsReducer from "./discountsReducer";
import landingsReducer from "./landingsReducer";
import bannersReducer from "./bannersReducer";
import headersReducer from "./headersReducer";
import footersReducer from "./footersReducer";
import homeCommentsReducer from "./homeCommentsReducer";
import homeCoveragesReducer from "./homeCoveragesReducer";
import homeDifferentialServicesReducer from "./homeDifferentialServicesReducer";
import homeWhyChooseUsReducer from "./homeWhyChooseUsReducer";
import homeProductNecessityReducer from "./homeProductNecessityReducer";
import homeLandingCitiesReducer from "./homeLandingCitiesReducer";
import notificationsReducer from "./notificationsReducer";
import alertsReducer from "./alertsReducer";
import ancillariesReducer from "./ancillariesReducer";
import ancillariesMasterReducer from "./ancillariesMasterReducer";
import stageRangeReducer from "./stageRangeReducer";
import ageGroupReducer from './ageGroupReducer';
import executiveGoalReducer from './executiveGoalReducer';
import agencyIncentiveReducer from './agencyIncentiveReducer';
import financingDiscountReducer from './financingDiscountReducer';
import backendScaleReducer from './backendScaleReducer';


export default combineReducers({
  alertsReducer,
  managersReducer,
  productsReducer,
  coveragesReducer,
  countriesReducer,
  countrycodesReducer,
  municipiosReducer,
  suppliersReducer,
  zonesReducer,
  categoriesReducer,
  groupsReducer,
  usersReducer,
  officesReducer,
  promotionsReducer,
  tagsReducer,
  businessUnitsReducer,
  currenciesReducer,
  passengersReducer,
  loginReducer,
  reservationsReducer,
  conciliationsReducer,
  vouchersReducer,
  ratesReducer,
  billingsReducer,
  productsSpertaReducer,
  facturacionReducer,
  blacklistReducer,
  paymentDetailReducer,
  discountsReducer,
  landingsReducer,
  bannersReducer,
  headersReducer,
  footersReducer,
  homeCommentsReducer,
  homeCoveragesReducer,
  homeDifferentialServicesReducer,
  homeWhyChooseUsReducer,
  homeProductNecessityReducer,
  homeLandingCitiesReducer,
  notificationsReducer,
  ancillariesReducer,
  ancillariesMasterReducer,
  stageRangeReducer,
  ageGroupReducer,
  executiveGoalReducer,
  agencyIncentiveReducer,
  financingDiscountReducer,
  backendScaleReducer
});
